module.exports = __webpack_public_path__ + "static/phone-slide-6-en-32c2465bd42db36e73f02cd88f9c742a.png";